import api from "./apiService";

export const getIdentity = () => api().get(`/identityMaster/`).then(response => response);

const services = {
    getIdentity
}

export default services;